import { useMemo } from 'react';
import NewGroup from '../ConnectedDeviceGroups/components/NewGroup';
import { useGetGroupsQuery } from 'services/devices/groups/groups.api';

// Shared add/edit group modal wrapper for the Connected Device Groups page.
export default function AddEditGroupModal({
  modalOpen,
  setModalOpen,
  resolveAddEditGroup,
  rejectAddEditGroup,
  isSubmitting = false,
}) {
  const {
    data: deviceGroups = [],
    isLoading: deviceGroupsLoading,
    isError: deviceGroupsError,
  } = useGetGroupsQuery();

  const initialData = useMemo(() => {
    if (modalOpen < 0) return {};
    return deviceGroups?.find((group) => group.id === modalOpen) || {};
  }, [deviceGroups, modalOpen]);

  if (modalOpen <= -2) return null;

  return (
    <NewGroup
      submit={resolveAddEditGroup}
      cancel={rejectAddEditGroup}
      show={modalOpen}
      setShow={() => setModalOpen(-2)}
      initialData={initialData}
      isSubmitting={isSubmitting}
    />
  );
}
